import { GetStaticProps } from 'next';
import {
	Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor,
	Enum_Componentinternaldefaultmoduleoptions_Padding,
	PageInformationFieldsFragment,
	SearchOverviewSingleFieldsFragment
} from 'api/graphql-types';
import Layout from 'modules/layout/layout';
import { ModuleBuilder } from 'modules/module-builder/module-builder';
import client from 'api/apollo-client';
import { Head } from 'modules/head/head';
import { getStrapiParametersFromContext } from 'utils/strapi-parameters';
import { getServerPageGetSearchOverview } from 'api/graphql-helper';
import { ROUTES } from 'constants/routes';
import { IBasePageProps } from 'types/page';
import SearchOverview from 'modules/search-overview/search-overview';
import { useRouter } from 'next/router';
import { getSearchSeo } from 'utils/global-search';

interface ISearchOverviewPageProps extends IBasePageProps {
	searchOverview?: SearchOverviewSingleFieldsFragment;
	pageInformation?: PageInformationFieldsFragment;
}

const SearchOverviewPage = ({ pageInformation, searchOverview }: ISearchOverviewPageProps): React.JSX.Element => {
	const { searchHeader, modules, Zoekresultaten } = { ...searchOverview };
	const seoModule = searchOverview?.seo;
	const router = useRouter();

	const headerDefaultOptions = {
		backgroundColor: 'white' as Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor,
		padding: 'none' as Enum_Componentinternaldefaultmoduleoptions_Padding
	};

	return (
		<Layout navbar={pageInformation?.navbar} footer={pageInformation?.footer}>
			<Head seoModule={getSearchSeo(router, seoModule)} seoParent={pageInformation?.seo} />
			<SearchOverview
				resultLabel={Zoekresultaten?.resultLabel || ''}
				header={{
					searchPlaceholder: searchHeader?.searchPlaceholder || '',
					headerTitle: searchHeader?.title || '',
					fullPath: ROUTES.SEARCH_OVERVIEW.fullPath
				}}
				headerDefaultOptions={headerDefaultOptions}
			/>
			<ModuleBuilder modules={modules || []} slug={ROUTES.SEARCH_OVERVIEW.fullPath} />
		</Layout>
	);
};

export const getStaticProps: GetStaticProps<ISearchOverviewPageProps> = async (ctx) => {
	try {
		const { locale, publicationState } = getStrapiParametersFromContext(ctx);

		const result = await getServerPageGetSearchOverview({ variables: { locale, publicationState } }, client);
		const { pageInformation, searchOverview } = result.props.data;

		if (searchOverview == null) {
			return {
				notFound: true
			};
		}

		return {
			props: {
				pageInformation: pageInformation?.data?.attributes,
				searchOverview: searchOverview.data?.attributes
			},
			revalidate: Number(process.env.NEXT_PUBLIC_REVALIDATE_TIME_IN_SECONDS)
		};
	} catch (error: any) {
		// eslint-disable-next-line no-console
		console.error('Error in search overview', error);

		return {
			notFound: true
		};
	}
};

export default SearchOverviewPage;
